import { CheckOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { useMemo, useState } from 'react';
import { Router } from 'react-router-dom';
import AppLayout from './AppLayout';
import './assets/styles/styles.scss';
import { TourProvider } from './contexts/TourContext';
import AuthProvider from './Guard/AuthContext';
import { RequestContext } from './helpers/requestContext';
import { history } from './utils/history.utils';

// Глобальная настройка message.success
const originalSuccess = message.success;
message.success = (config) => {
  if (typeof config === 'string') {
    return originalSuccess({
      content: <span style={{ fontSize: 15 }}>{config}</span>,
      duration: 4,
      icon: (
        <span className="card-order-success-message__icon">
          <CheckOutlined />
        </span>
      ),
      className: 'card-order-success-message',
    });
  }
  return originalSuccess(config);
};

const App = () => {
  const [createRequestFromDashboard, setCreateRequestFromDashboard] = useState(false);
  const value = useMemo(
    () => ({ createRequestFromDashboard, setCreateRequestFromDashboard }),
    [createRequestFromDashboard]
  );

  return (
    <Router history={history}>
      <AuthProvider>
        <TourProvider>
          <RequestContext.Provider value={value}>
            <AppLayout />
          </RequestContext.Provider>
        </TourProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
